import type { FaireProductEntity } from "../../entity_types/product";

export const p_kc9nz6mceg: FaireProductEntity = {
  token: "p_kc9nz6mceg",
  type: "product",
  name: "LM-SW-1007 Maroon/White Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/a157b97d43fd28f002adae54b172fb99dffe987fdabd611f976373e7b4992802.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This graphic sweatshirt from Girlie Girl Originals offers a stylish pullover silhouette with bold maroon and white accents, providing comfortable coverage and standout appeal. Ideal for layering or weekend looks, it brings a spirited, boutique-ready vibe to any wardrobe.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:37.814Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
